import { encodeBase32LowerCaseNoPadding } from "./encoding";

const KEYS = {
    'deliveryteamPlatformDataTable': 'cep',
    'deliveryteamOrdersDataTable': 'do',

    'userTable': 'u',

    'websitePageTable': 'page',

    'deliveryteamAtomicBalanceTransactionTable': 'dab_tra',

    'deliveryteamSupportWebsiteAtomicBalanceTransactionTable': 'dswab_tra',
    'deliveryteamMarketingWebsiteAtomicBalanceTransactionTable': 'dmwab_tra',

    'deliveryteamOrderStatusHistoryTable': 'dosh',
    'deliveryteamOrderLocationHistoryTable': 'dolh',

    'deliveryteamUserCreditBalanceHistoryTable': 'ducb_his',
    'deliveryteamStoreCreditBalanceHistoryTable': 'dscb_his',

    'storePlatformDataTable': 'str',
    'storeAssetTable': 'sa',
    'storeOrdersDataTable': 'so',
    'storeAtomicBalanceTransactionTable': 'sab_tra',
    'storeSupportWebsiteAtomicBalanceTransactionTable': 'sswab_tra',
    'storeMarketingWebsiteAtomicBalanceTransactionTable': 'smwab_tra',

    'storeAutoprintAppTable': 'dvc',
    'storeOrderStatusHistoryTable': 'sosh',
    'storeOrderUberDirectDeliveriesTable': 'soud',

    'storeUserCreditBalanceHistoryTable': 'sucb_his',

    'teamTable': 'team',

    'websitePlatformDataTable': 'web',
    'websiteAssetTable': 'wa',

    'courierPushTokenTable': 'cpt',

    'passkeyChallengeTable': 'pk_cha',
}

const keyPrefixes = Object.values(KEYS);
if (new Set(keyPrefixes).size !== keyPrefixes.length) {
    throw new Error('generateKey: KEYS prefix values must be unique');
}

export const generateKey = (key: keyof typeof KEYS) => {
    return `${KEYS[key]}_${generateIdFromEntropySize(8)}`;
}

// export const generateKey = (prefix: string) => {
//     return `${prefix}_${generateIdFromEntropySize(8)}`;
// }

export function generateIdFromEntropySize(size: number) {
    const buffer = crypto.getRandomValues(new Uint8Array(size));
    return encodeBase32LowerCaseNoPadding(buffer);
}
